import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rightArrow",
  "use": "icon-rightArrow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-rightArrow\">\n<title>rightArrow</title>\n<path d=\"M9.025 2.049l13.951 13.951-13.951 13.951z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol